module.exports = __webpack_public_path__ + "static/media/img4.aa525921.png";